import API from '../dataApi';

// -- Dashboard -----------------------------------------------------------------
export const getDashboard = (params) => API.get('/reports/dashboard', { params });
